import React from 'react';
import { Button, Icon } from '@tcc/crate';
import styles from '../RegionReport.css';

export type RegionReportNoteButtonProps = {
  title?: string;
}

export const RegionReportNoteButton = ({ title }: RegionReportNoteButtonProps) => (
  <Button
    className={styles.notePadContainer}
    data-test-id="region-report-note-button"
    mode="link"
  >
    <Icon glyph={Icon.set.NOTEPAD} />
    {title && (
      <h3 className={styles.notePadText} data-test-id="region-note-box-button-title">{title}</h3>
    )}
  </Button>
);
